<template>
  <div class="main-qa">
    <HeroSection
      :title="$c.text('pages.qa-hub.title')"
      title-class="h1"
      :subtitle="`${$c.text('pages.qa-hub.subtitle')} <a href='${$config.siteUrl}/community-guidelines/'>Community Guidelines.</a>`"
      button-title="Ask a question"
      button-link="/signup/"
      :image-url="`${$config.platform === 'fa' ? 'fa-' : ''}qa.jpg`"
      class-name="qa"
      columns="col-5"
    />
    <div class="content container">
      <div class="row">
        <div class="qa col-8 col">
          <Qa :key="key" :page="{ ...page, metaTitle }" :type="'main'" />
        </div>
        <div v-if="$store.state.layout === 'desktop'" class="col-4 col">
          <Banner v-if="!$store.getters['banners/promoBanner']" :banner-type="[0, 1]" />
          <SimilarQuestions :type="'popular'" :popular-questions="popularQuestions" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Qa from '@itbpbg/lms-components/src/Qa/Q&A.vue';
import HeroSection from '@itbpbg/lms-components/src/components/HeroSection';
import SimilarQuestions from '@itbpbg/lms-components/src/Qa/SimilarQuestions.vue';
import Banner from '@itbpbg/lms-components/src/Banner';

export default {
  components: {
    Qa,
    HeroSection,
    SimilarQuestions,
    Banner,
  },
  async asyncData({ $axios, route, $config }) {
    const { questions } = await $axios.$get('/qa-hub/questions?page=1&order=popularity');
    const page = await $axios.$get(`/pages/${route.fullPath}`).catch(() => false);
    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.metaFullImageUrl = `${$config.siteUrl}/resources/${page.metaImage}`;

    page.created = page.created || new Date();
    page.updated = page.updated || new Date();

    return {
      popularQuestions: questions,
      key: -1,
      page,
      metaTitle: `${page.metaTitle}${+route.query.page > 1 ? ` - Page ${route.query.page}` : ''}`,
    };
  },
  watch: {
    $route(v) {
      this.metaTitle = this.page.metaTitle;
      if (+v.query.page > 1) {
        this.metaTitle += ` – Page ${+v.query.page}`;
      }
    },
  },
  mounted() {
    this.key = 1;
  },
  created() {
    this.key = 1;
  },
};
</script>

<style lang="scss" scoped>
.main-qa {
  padding-bottom: var(--spacing-160);

  .content {
    padding-top: var(--spacing-44);

    .banners {
      margin-top: var(--spacing-sm);
    }
  }
}

@include bp($bp-mobile) {
  .banners {
    display: none;
  }
}

.fa {
  .main-qa {
    ::v-deep .hero-section-wrapper .container .row > div .btn-primary {
      max-width: 166px;
      height: 40px;
      border-radius: 3px;
      font-weight: 600;
      font-size: 16px;
      line-height: 150%;
      padding: 8px;
      color: var(--main-light-shade-1);
    }
  }
}

@include bp($bp-laptop) {
  .fa .main-qa ::v-deep .hero-section-wrapper .container .row > div .btn-primary {
    max-width: 225px;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@include bp($bp-mobile) {
  .fa {
    .main-qa {
      ::v-deep .hero-section-wrapper .container .row > div .btn-primary {
        max-width: 327px;
        height: 52px;
        display: flex;
        align-items: center;
        justify-content: center;

        @include bp($bp-phone) {
          margin: var(--spacing-30) auto 0;
        }
      }
    }
  }
}
</style>
